import { Input, DatePicker, Row, Col } from 'antd'
import { CreateEditFormItemProps } from './types'
import { useFDCTrackerContext } from '../../../../FDCTrackerContext'
import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import PayItemSelect from 'components/CIMSSelect/common/PayItemSelect'
import CustomFieldEditor from 'components/CustomFields/CustomFieldEditor'
import { FieldDesignChangeStatus } from 'shared'
import { useDisabledOptions } from 'hooks/useDisabledOptions'

const CreateEditFormItems: React.FC<CreateEditFormItemProps> = ({
  event,
  alreadyDisabled,
}) => {
  const {
    mutations: { edit, submit },
  } = useFDCTrackerContext()
  const twoCols = { xs: 24, xl: 12 } as const
  const [options, { some }] = useDisabledOptions([
    {
      disabled: !(event === 'edit' ? edit.can : submit.can),
      reason: 'missing permission',
    },
    {
      disabled: !!alreadyDisabled,
      reason: {
        why: 'invalid status',
        statusName: FieldDesignChangeStatus.Closed.name,
      },
    },
  ])
  return (
    <>
      <Row gutter={16}>
        <Col {...twoCols}>
          <CIMSFormItem
            name="drawingsAffected"
            label="Drawings Affected"
            disabled={options}
            help={HelpMessage.FieldDesignChanges.FDCTracker.DrawingsAffected}
          >
            <Input disabled={some} allowClear />
          </CIMSFormItem>
        </Col>
        <Col {...twoCols}>
          <CIMSFormItem
            name="specsAffected"
            label="Specs Affected"
            disabled={options}
            help={HelpMessage.FieldDesignChanges.FDCTracker.SpecsAffected}
          >
            <Input disabled={some} allowClear />
          </CIMSFormItem>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} xl={12} xxl={9}>
          <CIMSFormItem
            full
            name="requestedApprovalDate"
            label="Requested Approval Date"
            disabled={options}
            help={
              HelpMessage.FieldDesignChanges.FDCTracker.RequestedApprovalDate
            }
          >
            <DatePicker disabled={some} allowClear />
          </CIMSFormItem>
        </Col>
        <Col xs={24} xl={12} xxl={15}>
          <CIMSFormItem name="payItems" label="PayItems" full>
            <PayItemSelect multiple />
          </CIMSFormItem>
        </Col>
      </Row>
      <CustomFieldEditor
        alreadyDisabled={alreadyDisabled ?? false}
        hideBooleans={event !== 'create'}
      />
    </>
  )
}

export default CreateEditFormItems
